module.exports = __webpack_public_path__ + "img/weixin.1f37aa41.png";